import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../config';

export default function Exchange() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    bike_model: '',
    year: '',
    kilometers: '',
    city: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [alert, setAlert] = useState({ type: '', message: '' });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setAlert({ type: '', message: '' });

    try {
      const response = await fetch(`${API_BASE}/app/valuations`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await response.json();

      if (response.ok) {
        setAlert({
          type: 'success',
          message: 'Valuation request received! We will contact you soon.'
        });
        setFormData({
          name: '',
          phone: '',
          bike_model: '',
          year: '',
          kilometers: '',
          city: ''
        });
      } else {
        throw new Error(result.error || 'Failed to submit');
      }
    } catch (error) {
      setAlert({
        type: 'danger',
        message: error.message
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <div className="exchange-hero">
        <div className="container text-center">
          <h1 className="display-4 fw-bold">Sell or Exchange Your Bike</h1>
          <p className="lead">Get instant best price + bonus on exchange for a new bike</p>
        </div>
      </div>

      <div className="container my-5">
        <div className="row g-5">
          <div className="col-lg-6">
            <div className="form-card">
              <h3 className="fw-bold mb-4">Request Free Valuation</h3>
              <form onSubmit={handleSubmit}>
                {alert.message && (
                  <div className={`alert alert-${alert.type}`} role="alert">
                    {alert.message}
                  </div>
                )}
                <div className="mb-3">
                  <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    name="name"
                    placeholder="Your Name" 
                    value={formData.name}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="mb-3">
                  <input 
                    type="tel" 
                    className="form-control form-control-lg" 
                    name="phone"
                    placeholder="Phone Number" 
                    value={formData.phone}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="mb-3">
                  <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    name="bike_model"
                    placeholder="Bike Model (e.g., Honda Activa)" 
                    value={formData.bike_model}
                    onChange={handleInputChange}
                    required 
                  />
                </div>
                <div className="mb-3">
                  <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    name="year"
                    placeholder="Year of Registration"
                    value={formData.year}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-3">
                  <input 
                    type="text" 
                    className="form-control form-control-lg" 
                    name="kilometers"
                    placeholder="Kilometers Driven"
                    value={formData.kilometers}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="mb-4">
                  <select 
                    className="form-select form-select-lg" 
                    name="city"
                    value={formData.city}
                    onChange={handleInputChange}
                  >
                    <option value="">Select City</option>
                    <option value="Mumbai">Mumbai</option>
                    <option value="Delhi">Delhi</option>
                    <option value="Pune">Pune</option>
                    <option value="Bangalore">Bangalore</option>
                  </select>
                </div>
                <button 
                  type="submit" 
                  className="btn-exchange" 
                  disabled={submitting}
                >
                  <i className="fas fa-rupee-sign me-2"></i> 
                  {submitting ? 'Submitting...' : 'Get Best Price'}
                </button>
              </form>
              <p className="text-muted mt-3 text-center">
                <i className="fas fa-shield-alt me-1"></i> Free inspection • No hidden charges
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="fw-bold mb-3">Why Exchange with Shivam Moto?</h3>
            <div className="benefit-box mb-3">
              <i className="fas fa-tachometer-alt fa-2x text-warning"></i>
              <h5 className="mt-2">Instant On-spot Valuation</h5>
              <p>Expert evaluation within 30 minutes</p>
            </div>
            <div className="benefit-box mb-3">
              <i className="fas fa-hand-holding-usd fa-2x text-warning"></i>
              <h5 className="mt-2">Best Price Guarantee</h5>
              <p>We match any genuine offer + extra exchange bonus</p>
            </div>
            <div className="benefit-box">
              <i className="fas fa-file-alt fa-2x text-warning"></i>
              <h5 className="mt-2">Paperwork Assistance</h5>
              <p>Complete RTO transfer support & documentation</p>
            </div>
          </div>
        </div>
      </div>

      <div className="container text-center py-4">
        <div className="bg-warning bg-opacity-10 p-5 rounded-5">
          <h3 className="fw-bold">Upgrade to a New Bike Today!</h3>
          <p className="fs-5">Exchange bonus up to ₹5,000 + special finance options</p>
          <Link to="/new-bikes" className="btn btn-dark btn-lg rounded-pill px-5">
            Explore New Bikes
          </Link>
        </div>
      </div>
    </>
  );
}
